// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zYow","right":"styles_right__3h5Wa"};